export default {
  hero_title: 'よくあるご質問',
  hero_desc: 'AIX JAPANのサービスに関するよくあるご質問をまとめました。\nこちらに掲載のない内容はお気軽にお問い合わせください。',
  cat_consulting: 'AIX Consulting',

  meta_title: 'よくあるご質問 | AIX JAPAN – AI・DXコンサルティングFAQ',
  meta_description: 'AIX JAPANへのよくある質問。サービス概要・費用感・期間・研修メニュー・AIガバナンス対応など、AIコンサルティング・DX推進・AI人材育成に関するFAQを掲載しています。',
  meta_keywords: 'FAQ,よくある質問,AIコンサルティング,DX推進,AIX JAPAN',

  faq_data: [
    {
      category: 'サービス全般',
      questions: [
        { q: 'AIX JAPANのコンサルティングサービスはどのような企業に向いていますか？', a: 'AI活用・DX推進を検討しているすべての企業様にご活用いただけます。特に「AI戦略をどこから始めればよいかわからない」「社内にAI人材がいない」「DX推進が進んでいない」といった課題を抱える企業様に多くご利用いただいています。業種・規模を問わず、製造・金融・小売・医療・インフラなど幅広い業界でご支援実績がございます。' },
        { q: '初回相談は無料ですか？', a: 'はい、初回のご相談は無料で承っております。まずはお気軽にお問い合わせフォームよりご連絡ください。弊社の担当コンサルタントが貴社の課題やニーズをヒアリングし、最適なサービスをご提案させていただきます。' },
        { q: '小規模な企業でも相談できますか？', a: 'もちろんです。従業員数・売上規模に関わらずご相談を承っております。スタートアップから大企業まで、それぞれの規模・フェーズに合わせた最適なAI活用戦略をご提案いたします。' },
      ],
    },
    {
      category: 'AIX Consulting',
      questions: [
        { q: 'AI戦略の立案から実装まで、どのくらいの期間がかかりますか？', a: '企業規模や課題の複雑さによって異なりますが、AI戦略立案フェーズは通常1〜3ヶ月、実装・定着支援まで含めると6ヶ月〜1年程度を目安にしていただいています。' },
        { q: 'コンサルティング費用の目安はどのくらいですか？', a: 'ご支援の範囲・期間・体制によって異なります。AI現状診断のみのスポット支援から、戦略立案〜実行支援まで一気通貫でお任せいただく長期支援まで、柔軟なプランをご用意しております。' },
        { q: 'AI導入後のサポート体制はどうなっていますか？', a: '導入後も継続的なモニタリングと改善支援を提供しています。定期的なレビューセッション、KPI分析、追加施策の提案など、AI活用が現場に定着するまで伴走支援を行います。' },
      ],
    },
    {
      category: 'AIX Training',
      questions: [
        { q: 'AIX Trainingはどのような研修メニューがありますか？', a: '経営層向けの「AI戦略・意思決定研修」、マネージャー向けの「AIマネジメント研修」、現場担当者向けの「AIリテラシー基礎研修」、エンジニア向けの「AI実装・活用研修」など、階層・職種別に体系的なカリキュラムをご用意しています。' },
        { q: '研修はオンラインと対面どちらで受講できますか？', a: 'オンライン・対面・ハイブリッドのいずれにも対応しています。' },
        { q: '研修効果の測定はできますか？', a: 'はい、受講前後のAIリテラシー診断テスト、研修後のアクションプラン実施率など、複数の指標で効果測定を行います。' },
      ],
    },
    {
      category: 'AIX Manager',
      questions: [
        { q: 'AIX Managerサービスとは具体的にどのような内容ですか？', a: 'AIマネジメントアドバイザリーサービスです。AI推進組織の設計・体制構築、AIガバナンス・リスク管理フレームワークの策定など、組織全体でAIを適切に管理・活用するための仕組みづくりをサポートします。' },
        { q: 'AIガバナンスの整備も支援していただけますか？', a: 'はい、AIガバナンスの整備は重要な支援領域のひとつです。AI倫理ポリシーの策定、データ管理ルールの整備、AI活用の審査プロセス設計など、適切なガバナンス体制の構築を包括的にサポートいたします。' },
      ],
    },
  ],
};